import { makeAutoObservable, observable, toJS  } from "mobx";
import mainStore from "../../home/store/mainStore";
import { FiscalizationService } from "../services/fiscalizationservice";
import moment from "moment";
import { getCurrentUser } from "../../../Utility/modules/helpers";

class FiscalizationStore {
  constructor() {
    makeAutoObservable(this);
  }

  sheetName = "Fiscalization Template";
  isIniatilizing = false;
  disableCommand = true;
  targetYear = moment(new Date()).format("YYYY");
  isloading = false;
  importedFiscalization = [];
  showFiscalizationDialog = false;

  hasImported = false;
  isSaving = false;
  showEquityDialog = false;
  mainStore = mainStore;
  showTargetEditDialog = false;
  isSavingEquity = false;
  isSavingMonthlyTarget = false;
  fiscalizations = observable.map({});
  selRow = {};
  prompt = true;
  async loadFiscalizationData() {
    const assetId = mainStore.assetContextId;
    this.importedFiscalization = [];
    this.hasImported = false;

    try {
      this.isloading = true;
      const res = await FiscalizationService.getAssetFiscalizationByYear(
        this.targetYear,
        assetId
      );
      this.selRow = {};
      this.fiscalizations.clear();
      res.fiscalizations.forEach((t) => {
        this.fiscalizations.set(t.fiscalizationId, t);
      });
    } catch (error) {
      throw error;
    } finally {
      this.isloading = false;
    }
  }

  async initailizeFiscalzation() {
    try {
      this.isIniatilizing = true;
      const assetId = mainStore.assetContextId;

      const uploadedBy = getCurrentUser()?.fullName;
      const res = await FiscalizationService.initailizeFiscalzation(
        this.targetYear,
        assetId,
        uploadedBy
      );
      this.fiscalizations.clear();
      res.fiscalizations.forEach((t) => {
        this.fiscalizations.set(t.fiscalizationId, t);
      });
      this.isIniatilizing = false;
    } catch (error) {
      throw error;
    } finally {
      this.isIniatilizing = false;
    }
  }

  get importHasRows() {
    return this.importedFiscalization.length > 0;
  }

  async saveMonthFiscalization(fiscal) {
    try {
      this.isSavingMonthlyTarget = true;
      const uploadedBy = getCurrentUser()?.fullName;
      const retVal = await FiscalizationService.saveMonthTarget(
        fiscal,
        uploadedBy
      );
      return retVal;
    } catch (error) {
      throw error;
    }
  }

  clearForm() {
    const initData = {
      ...toJS(this.selRow),
      comments: "",
      condensateTarget: 0,
      gastoPlant: 0,
      nglTarget: 0,
      oilProduced: 0,
      oilRecieved: 0,
      gasProduced: 0,
    };

    this.selRow = initData;
  }
}



const fiscalizationStore = new FiscalizationStore();
export default fiscalizationStore;

